// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__QTbK6","navButton":"Pagination_navButton__D8pDE"};